package com.mxpainting.components.sections

import androidx.compose.runtime.Composable
import com.mxpainting.Language
import com.mxpainting.Strings
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

private data class OfferItem(val icon: String, val title: String, val description: String)

@Composable
fun WhatWeOffer(language: Language) {
    val offers = listOf(
        OfferItem("fa-paint-roller", Strings.homeOfferMaterialsTitle[language]!!, Strings.homeOfferMaterialsDesc[language]!!),
        OfferItem("fa-user-check", Strings.homeOfferServiceTitle[language]!!, Strings.homeOfferServiceDesc[language]!!),
        OfferItem("fa-file-invoice-dollar", Strings.homeOfferEstimatesTitle[language]!!, Strings.homeOfferEstimatesDesc[language]!!),
        OfferItem("fa-shield-alt", Strings.homeOfferInsuredTitle[language]!!, Strings.homeOfferInsuredDesc[language]!!)
    )

    Section(Modifier.classNames("section-dark").toAttrs()) {
        Div(Modifier.classNames("container").toAttrs()) {
            H2(Modifier.classNames("text-center", "mb-5").toAttrs()) { Text(Strings.homeOfferHeader[language]!!) }
            Div(Modifier.classNames("row", "g-4", "justify-content-center").toAttrs()) {
                offers.forEach { item ->
                    Div(Modifier.classNames("col-lg-3", "col-md-6").toAttrs()) {
                        Div(Modifier.classNames("offer-card").toAttrs()) {
                            Div(Modifier.classNames("offer-icon").toAttrs()) {
                                I(Modifier.classNames("fas", item.icon).toAttrs()) {}
                            }
                            H5 { Text(item.title) }
                            P { Text(item.description) }
                        }
                    }
                }
            }
        }
    }
}
